/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const name = 'customActions';

const initialState = createInitialState();

const slice = createSlice({
    name,
    initialState,
    reducers: {
        toggleCreateBtnTrue(state) {
            state.isCreateBtnClicked = true;
        },
        toggleCreateBtnFalse(state) {
            state.isCreateBtnClicked = false;
        },
        setManageListingFilters(state, action) {
            if (action.payload.selectedAM || action?.payload?.selectedAM === null) {
                state.manageListing.selectedAM = action.payload.selectedAM || null;
            }
            if (action.payload.selectedFilter || action?.payload?.selectedFilter === null) {
                state.manageListing.selectedFilter = action.payload.selectedFilter || null;
            }
            if (action.payload.selectedComplex || action?.payload?.selectedComplex === null) {
                state.manageListing.selectedComplex = action.payload.selectedComplex || null;
            }
            if (action.payload.selectedFloorPlan || action?.payload?.selectedFloorPlan === null) {
                state.manageListing.selectedFloorPlan = action.payload.selectedFloorPlan || null;
            }
            if (action.payload.search || action?.payload?.search === '') {
                state.manageListing.search = action?.payload?.search || '';
            }
        },
        clearManageListingFilters(state) {
            state.manageListing = {
                search: '',
                selectedAM: null,
                selectedFilter: null,
                selectedComplex: null,
                selectedFloorPlan: null
            };
        },
        toggleArchieveBtnTrue(state) {
            state.isArchivedBtnClicked = true;
        },
        toggleArchieveBtnFalse(state) {
            state.isArchivedBtnClicked = false;
        }
    }
});

export const {
    toggleCreateBtnTrue,
    toggleCreateBtnFalse,
    setManageListingFilters,
    clearManageListingFilters,
    toggleArchieveBtnTrue,
    toggleArchieveBtnFalse
} = slice.actions;

export default slice.reducer;

function createInitialState() {
    return {
        isArchivedBtnClicked: false,
        isCreateBtnClicked: false,
        manageListing: {
            search: null,
            selectedAM: null,
            selectedFilter: null,
            selectedComplex: null,
            selectedFloorPlan: null
        }
    };
}
